import request from '@/utils/request'
import URL from './urlTranslator'

// 增加港口要求
export function addSeaPortRequirement(data) {
  return request({
    url: URL.mdm.seaPortRequirement.addSeaPortRequirement,
    method: 'post',
    data
  })
}
// 根据uuid批量删除港口要求
export function batchDelSeaPortRequirement(uuids) {
  const data = uuids
  // console.log('-------------------data', data)
  return request({
    url: URL.mdm.seaPortRequirement.batchDelSeaPortRequirement,
    method: 'delete',
    data
  })
}
// 更新港口要求
export function updateSeaPortRequirement(data) {
  return request({
    url: URL.mdm.seaPortRequirement.updateSeaPortRequirement,
    method: 'put',
    data
  })
}
// 查询港口要求
export function querySeaPortRequirementList(params) {
  return request({
    url: URL.mdm.seaPortRequirement.querySeaPortRequirementList,
    method: 'get',
    params
  })
}

